module.exports = __webpack_public_path__ + "img/lf_map.88f43c27.jpg";